import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';

import {
  CreditEarlyRepaymentPaymentType,
  CreditEarlyRepaymentPopupData,
  CreditEarlyRepaymentStatus,
} from './credit-early-repayment-quard-popup.model';

@Injectable({providedIn: 'root'})
export class CreditEarlyRepaymentGuardPopupService {

	public openEarlyRepaymentPopup$: Observable<CreditEarlyRepaymentPopupData>;

	private openEarlyRepaymentPopup$$: Subject<CreditEarlyRepaymentPopupData> = new Subject();

	constructor() {
		this.openEarlyRepaymentPopup$ = this.openEarlyRepaymentPopup$$.asObservable();
	}

	public openEarlyRepaymentPopup(paymentStatus: CreditEarlyRepaymentStatus | undefined, paymentType: CreditEarlyRepaymentPaymentType | undefined): void {
		this.openEarlyRepaymentPopup$$.next({
			...(paymentStatus || {} as CreditEarlyRepaymentStatus),
			paymentType,
		});
	}

}
